var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9319 27.0799L28.9821 15.0765C28.9968 14.8526 28.9671 14.6281 28.8947 14.4157C28.7586 13.9883 28.4595 13.6319 28.0623 13.4236C27.8657 13.3155 27.6497 13.2473 27.4267 13.2229L15.4233 12.1727C15.1994 12.1531 14.9739 12.1778 14.7597 12.2454C14.5454 12.313 14.3465 12.4221 14.1744 12.5665C13.8267 12.8582 13.6092 13.276 13.5697 13.7281C13.5301 14.1801 13.6718 14.6294 13.9635 14.977C14.2551 15.3246 14.673 15.5421 15.125 15.5817L23.0363 16.2617L13.1287 24.5753C12.7825 24.8658 12.5658 25.2819 12.5265 25.7321C12.4871 26.1823 12.6281 26.6298 12.9186 26.976C13.2091 27.3222 13.6253 27.5388 14.0755 27.5782C14.5257 27.6176 14.9731 27.4765 15.3193 27.186L25.227 18.8725L24.5229 26.7817C24.5024 27.0057 24.5264 27.2315 24.5937 27.4462C24.6609 27.6609 24.7699 27.8602 24.9145 28.0325C25.0591 28.2048 25.2364 28.3468 25.4361 28.4502C25.6359 28.5537 25.8541 28.6166 26.0783 28.6353C26.3023 28.6558 26.5282 28.6318 26.7429 28.5646C26.9575 28.4974 27.1568 28.3883 27.3291 28.2437C27.5014 28.0991 27.6434 27.9218 27.7469 27.7221C27.8503 27.5224 27.9132 27.3041 27.9319 27.0799Z",
    fill: "#393185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/ARROW-1.1128281200049eb680a3ef80fc3245a7.svg";
export { ForwardRef as ReactComponent };